import Handlebars from "handlebars/runtime";
import toastr from "toastr";
import VueI18n from "@Shared/@i18n";
import Cookies from "js-cookie";
import { DeviceUUID } from "device-uuid";
import VueInit from "@Shared/utils/vue";
import firebase from "firebase/app";
import Vue from "vue";
import store from "./store";
import VueRouter from "./routes/vue-router";
import { bindGlobalErrorBoundary } from "./routes/error";
import App from "./modules/app";
import jqueryEvents from "@Shared/utils/events";
import jqueryExtra from "@Shared/utils/jquery-extra";
import handlebarsHelpers from "@Shared/utils/helpers";
import { TOASTR_OPTIONS } from "@Shared/utils/constants";
import Amplitude from "@Shared/utils/amplitude";
import TitleMixin from "@Shared/@Utils/shared-mixins/title-mixin";
import { clearDeprecatedStorage } from "@Shared/@Utils/utils";
VueInit();
Amplitude.init("broker");
Vue.mixin(TitleMixin("brokerPortalDocumentTitle"));
window.idleTime = 0;
(() => {
  bindGlobalErrorBoundary();
  const initFirebase = () => {
    try {
      if (!Cookies.get("fcmDeviceId")) {
        const deviceId = new DeviceUUID().get();
        Cookies.set("fcmDeviceId", deviceId, {
          expires: 3650
        }); //TODO: check how to renew this if needed
      }
      if (!firebase.messaging.isSupported()) return;
      firebase.initializeApp(process.env.FIREBASE_CONFIG);
    } catch (e) {
      Amplitude.logHandledError(e);
    }
  };
  $(document).ready(async () => {
    //clear old sammy store
    clearDeprecatedStorage();
    toastr.options = TOASTR_OPTIONS;
    initFirebase();
    handlebarsHelpers.register(Handlebars);
    jqueryEvents.init();
    jqueryExtra.init(window.$);
    $.fn.serializeJSONNoFill = function (options) {
      const serialized = this.serializeJSON(options);
      if (serialized.emailNoFill) {
        serialized.email = serialized.emailNoFill;
        delete serialized.emailNoFill;
      }
      return serialized;
    };
    new Vue({
      i18n: VueI18n,
      router: VueRouter,
      store,
      data: {
        //used to save the reference of opened popover window
        widgetPopover: null
      },
      render: h => h(App)
    }).$mount("#body");
  });
})();